
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

var $a2dfdde8c88a3d83$exports = {};

(parcelRequire("1hiTA")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"GD9EA\",\"Controller.a8e601c7.js\",\"9XXCk\",\"tooltip.a5f1908b.js\",\"l9aze\",\"main.6a2abb99.js\",\"jZMUd\",\"MainButtons.8845ded8.js\",\"dBsbZ\",\"main.03a3297c.js\",\"fFsaR\",\"main.0e39ee4b.js\",\"g8N2Z\",\"main.50640655.js\",\"k9RdS\",\"main.772f88f4.js\",\"aQPG0\",\"cs.17c504ef.js\",\"bkZFg\",\"da.3f62a1e3.js\",\"55jRH\",\"de.fbd7c76e.js\",\"7gZXw\",\"en.c472fadc.js\",\"b3SDM\",\"en_GB.9514c013.js\",\"1JMhO\",\"en_ZZ.ac52ff98.js\",\"9yhAT\",\"es.98e38d09.js\",\"cdSjM\",\"et.645fa2a3.js\",\"d5cjH\",\"fi.4b6971bc.js\",\"cM3qB\",\"fr.816d1957.js\",\"ju3RT\",\"hu.6d4d60e0.js\",\"eKgTI\",\"is.f17fff44.js\",\"4SiFB\",\"it.6214ac6e.js\",\"3sB8d\",\"ja.88bdc3e4.js\",\"cufjc\",\"ko.5b85c97c.js\",\"hPzC3\",\"nb.d2d69afd.js\",\"cjMnf\",\"nl.d6476d28.js\",\"bdFVZ\",\"pl.18dd440f.js\",\"73TPf\",\"pt_BR.cfa55c8c.js\",\"84JCz\",\"pt_PT.8eb0304b.js\",\"e9I4V\",\"ro.ca387467.js\",\"11Tbc\",\"ru.279e6b0a.js\",\"9tJmD\",\"sk.d25b66d5.js\",\"15Pfi\",\"sv.f63217dc.js\",\"5JkSw\",\"th.cadc6f18.js\",\"8yuuY\",\"tr.029d51e5.js\",\"gYFls\",\"uk.eaa3b47f.js\",\"4tohK\",\"vi.ee717bc1.js\",\"iXqHo\",\"zh_TW.3a744e1c.js\",\"lcic8\",\"zh.bb033424.js\"]"));


$parcel$global.rlb("gbejv")
//# sourceMappingURL=Controller.runtime.eeeaba94.js.map
